export const MagicBackground = () => (
  <svg
    width="1072"
    height="608"
    viewBox="0 0 1072 608"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.0793 538.424C19.0793 538.424 19.7315 529.442 16.3445 525.228C12.9575 521.014 3.31961 518.818 3.31961 518.818C3.31961 518.818 13.3227 519.119 18.1322 515.947C22.9416 512.776 25.6981 504.061 25.6981 504.061C25.6981 504.061 25.0459 513.043 28.4329 517.257C31.8199 521.471 41.4578 523.667 41.4578 523.667C41.4578 523.667 31.4548 523.367 26.6453 526.538C21.8358 529.709 19.0793 538.424 19.0793 538.424Z"
      fill="white"
      fillOpacity="0.51"
    />
    <path
      d="M254.618 34.47C254.618 34.47 255.344 28.7358 254.363 26.1795C253.383 23.6233 250.054 22.5758 250.054 22.5758C250.054 22.5758 253.617 22.4046 255.512 20.2141C257.408 18.0235 258.872 12.3832 258.872 12.3832C258.872 12.3832 258.146 18.1174 259.127 20.6737C260.107 23.2299 263.436 24.2774 263.436 24.2774C263.436 24.2774 259.873 24.4486 257.978 26.6391C256.082 28.8297 254.618 34.47 254.618 34.47Z"
      fill="white"
      fillOpacity="0.51"
    />
    <ellipse
      cx="7.25137"
      cy="7.37935"
      rx="7.25137"
      ry="7.37935"
      transform="matrix(-0.992012 -0.126145 0.189139 -0.98195 60.3711 231.812)"
      fill="white"
      fillOpacity="0.77"
    />
    <ellipse
      cx="4.57655"
      cy="4.65732"
      rx="4.57655"
      ry="4.65732"
      transform="matrix(-0.992012 -0.126145 0.189139 -0.98195 416.08 561.302)"
      fill="white"
      fillOpacity="0.77"
    />
    <ellipse
      cx="4.00098"
      cy="4.0716"
      rx="4.00098"
      ry="4.0716"
      transform="matrix(-0.992012 -0.126145 0.189139 -0.98195 280.83 35.7427)"
      fill="white"
      fillOpacity="0.77"
    />
    <path
      d="M62.4327 170.472C62.4327 170.472 63.285 159.111 59.1052 153.793C54.9255 148.475 42.9843 145.728 42.9843 145.728C42.9843 145.728 55.3875 146.076 61.3671 142.05C67.3466 138.024 70.8071 126.995 70.8071 126.995C70.8071 126.995 69.9548 138.356 74.1346 143.673C78.3144 148.991 90.2555 151.739 90.2555 151.739C90.2555 151.739 77.8523 151.39 71.8728 155.416C65.8932 159.442 62.4327 170.472 62.4327 170.472Z"
      fill="white"
      fillOpacity="0.51"
    />
    <path
      d="M852.773 210.117C852.773 210.117 853.286 203.278 850.77 200.076C848.254 196.875 841.065 195.221 841.065 195.221C841.065 195.221 848.532 195.431 852.131 193.007C855.731 190.584 857.814 183.944 857.814 183.944C857.814 183.944 857.301 190.783 859.818 193.985C862.334 197.186 869.523 198.84 869.523 198.84C869.523 198.84 862.056 198.63 858.456 201.054C854.856 203.478 852.773 210.117 852.773 210.117Z"
      fill="white"
      fillOpacity="0.51"
    />
    <ellipse
      cx="3.93994"
      cy="3.50829"
      rx="3.93994"
      ry="3.50829"
      transform="matrix(-0.992012 -0.126145 0.189139 -0.98195 943.322 123.02)"
      fill="white"
      fillOpacity="0.77"
    />
    <ellipse
      cx="4.11361"
      cy="3.66294"
      rx="4.11361"
      ry="3.66294"
      transform="matrix(-0.992012 -0.126145 0.189139 -0.98195 835.027 43.5806)"
      fill="white"
      fillOpacity="0.77"
    />
    <ellipse
      cx="5.36448"
      cy="4.77676"
      rx="5.36448"
      ry="4.77676"
      transform="matrix(-0.992012 -0.126145 0.189139 -0.98195 817.498 504.63)"
      fill="white"
      fillOpacity="0.77"
    />
    <ellipse
      cx="5.33821"
      cy="4.75337"
      rx="5.33821"
      ry="4.75337"
      transform="matrix(-0.992012 -0.126145 0.189139 -0.98195 678.535 411.136)"
      fill="white"
      fillOpacity="0.77"
    />
    <ellipse
      cx="3.12163"
      cy="2.77963"
      rx="3.12163"
      ry="2.77963"
      transform="matrix(-0.992012 -0.126145 0.189139 -0.98195 941.955 387.319)"
      fill="white"
      fillOpacity="0.77"
    />
    <ellipse
      cx="5.14523"
      cy="4.58154"
      rx="5.14523"
      ry="4.58154"
      transform="matrix(-0.992012 -0.126145 0.189139 -0.98195 281.668 403.123)"
      fill="white"
      fillOpacity="0.77"
    />
    <path
      d="M159.688 315.592C159.688 315.592 160.34 306.745 157.038 302.599C153.737 298.452 144.328 296.299 144.328 296.299C144.328 296.299 154.097 296.585 158.799 293.456C163.502 290.327 166.208 281.742 166.208 281.742C166.208 281.742 165.557 290.589 168.858 294.735C172.159 298.881 181.569 301.035 181.569 301.035C181.569 301.035 171.799 300.749 167.097 303.878C162.394 307.006 159.688 315.592 159.688 315.592Z"
      fill="white"
      fillOpacity="0.51"
    />
    <path
      d="M290.265 519.557C290.265 519.557 290.864 511.426 287.83 507.615C284.796 503.804 276.148 501.825 276.148 501.825C276.148 501.825 285.127 502.088 289.448 499.212C293.77 496.337 296.258 488.446 296.258 488.446C296.258 488.446 295.659 496.577 298.693 500.388C301.727 504.199 310.375 506.178 310.375 506.178C310.375 506.178 301.396 505.915 297.074 508.791C292.753 511.666 290.265 519.557 290.265 519.557Z"
      fill="white"
      fillOpacity="0.51"
    />
    <path
      d="M854.778 578.348C854.778 578.348 855.275 571.601 852.757 568.439C850.24 565.277 843.064 563.635 843.064 563.635C843.064 563.635 850.514 563.852 854.1 561.466C857.687 559.08 859.75 552.533 859.75 552.533C859.75 552.533 859.254 559.28 861.771 562.442C864.289 565.604 871.465 567.246 871.465 567.246C871.465 567.246 864.014 567.028 860.428 569.414C856.842 571.8 854.778 578.348 854.778 578.348Z"
      fill="white"
      fillOpacity="0.51"
    />
    <path
      d="M37.7074 504.649C37.7074 504.649 38.2953 496.665 35.3161 492.923C32.3369 489.181 23.8451 487.238 23.8451 487.238C23.8451 487.238 32.6616 487.495 36.9054 484.672C41.1492 481.848 43.5916 474.1 43.5916 474.1C43.5916 474.1 43.0036 482.084 45.9828 485.826C48.962 489.568 57.4538 491.511 57.4538 491.511C57.4538 491.511 48.6374 491.254 44.3935 494.077C40.1497 496.9 37.7074 504.649 37.7074 504.649Z"
      fill="white"
      fillOpacity="0.51"
    />
    <path
      d="M806.461 41.2536C806.461 41.2536 807.185 31.4161 803.515 26.8056C799.844 22.195 789.381 19.8007 789.381 19.8007C789.381 19.8007 800.244 20.1182 805.473 16.6393C810.702 13.1604 813.711 3.61349 813.711 3.61349C813.711 3.61349 812.986 13.451 816.657 18.0615C820.328 22.6721 830.791 25.0664 830.791 25.0664C830.791 25.0664 819.928 24.7489 814.699 28.2278C809.47 31.7067 806.461 41.2536 806.461 41.2536Z"
      fill="white"
      fillOpacity="0.51"
    />
    <path
      d="M639.743 604.995C639.743 604.995 640.596 593.634 636.416 588.317C632.236 582.999 620.295 580.251 620.295 580.251C620.295 580.251 632.698 580.6 638.678 576.574C644.657 572.548 648.118 561.519 648.118 561.519C648.118 561.519 647.265 572.88 651.445 578.197C655.625 583.515 667.566 586.263 667.566 586.263C667.566 586.263 655.163 585.914 649.183 589.94C643.204 593.966 639.743 604.995 639.743 604.995Z"
      fill="white"
      fillOpacity="0.51"
    />
    <path
      d="M487.361 473.014C487.361 473.014 487.783 467.397 485.716 464.768C483.65 462.138 477.746 460.78 477.746 460.78C477.746 460.78 483.878 460.952 486.835 458.962C489.791 456.972 491.502 451.519 491.502 451.519C491.502 451.519 491.08 457.136 493.147 459.765C495.213 462.394 501.117 463.752 501.117 463.752C501.117 463.752 494.985 463.58 492.029 465.57C489.072 467.561 487.361 473.014 487.361 473.014Z"
      fill="white"
      fillOpacity="0.51"
    />
    <path
      d="M639.734 604.996C639.734 604.996 640.586 593.635 636.406 588.317C632.226 582.999 620.285 580.252 620.285 580.252C620.285 580.252 632.688 580.6 638.668 576.574C644.647 572.548 648.108 561.519 648.108 561.519C648.108 561.519 647.256 572.88 651.435 578.198C655.615 583.516 667.556 586.263 667.556 586.263C667.556 586.263 655.153 585.915 649.174 589.941C643.194 593.967 639.734 604.996 639.734 604.996Z"
      fill="white"
      fillOpacity="0.51"
    />
    <ellipse
      cx="1.97825"
      cy="1.76152"
      rx="1.97825"
      ry="1.76152"
      transform="matrix(-0.992012 -0.126145 0.189139 -0.98195 1010.6 489.27)"
      fill="white"
      fillOpacity="0.77"
    />
  </svg>
);
